import { createTheme } from "@mui/material/styles";
import { Colors, ColorMappings } from "../constants/colors";
import muiIcons from "./muiIcons";
import muiSvgIcons from "./muiSvgIcons";
import muiMenuItem from "./muiMenuItem";
import muiStepLabel from "./muiStepLabel";
import muiPaper from "./muiPaper";
import muiFormControl from "./muiFormControl";
import muiAppBar from "./muiAppBar";
import muiToolbar from "./muiToolbar";
import { muiTabs, muiTab } from "./muiTabs";
import muiIconButton from "./muiIconButton";
import muiButton from "./muiButton";
import muiAlert from "./muiAlert";
import muiLink from "./muiLink";
import muiChip from "./muiChip";
import muiSwitch from "./muiSwitch";
import muiTextField from "./muiTextField";
import muiTooltip from "./muiTooltip";
import muiListSubheader from "./muiListSubheader";
import muiDivider from "./muiDivider";
import muiCheckbox from "./muiCheckbox";
import muiAccordionSummary from "./muiAccordionSummary";
import muiButtonGroup from "./muiButtonGroup";
import muiSlider from "./muiSlider";
import muiRating from "./muiRating";
import muiFormHelperText from "./muiFormHelperText";
import muiCalendarPicker from "./muiCalendarPicker";
import muiDialog from "./muiDialog";
import muiToggleButton from "./muiToggleButton";
import muiToggleButtonGroup from "./muiToggleButtonGroup";
import muiBadge from "./muiBadge";

import AllStyles from "./styles";
import sfHaloIcon from "./sfHaloIcon";
import muiFormControlLabel from "./muiFormControlLabel";

const getTransColorsObj = () => {
  let obj = {};
  Object.keys(Colors).forEach((key) => {
    let backgroundColor = Colors[key];
    obj[key.toLocaleLowerCase()] = {
      main: backgroundColor,
      contrastText:
        ColorMappings.find((x) => x.backgroundColor == backgroundColor)
          ?.fontColor ?? Colors.WHITE,
    };
  });
  return obj;
};
//const { i18n } = useTranslation();
//const currentLanguage = i18n.language;

const getTheme = (dir = null) => {
  const theme = createTheme({
    ...(dir && {
      direction: dir,
    }),
    screenMaxWidth: 1920,
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536,
        xxl: 1920,
      },
    },
    //this changes the z-index of the snackbar(notifications popups)
    zIndex: {
      snackbar: 99999,
    },
    typography: {
      fontFamily: [
        "ey_interstate",
        "noto_sans",
        "Helvetica Neue",
        "Arial",
        "sans-serif",
      ].join(","),
      fontSize: 12,

      ...AllStyles,
    },
    shape: {
      borderRadius: 2,
    },
    palette: {
      type: "light",
      contrastThreshold: 4.5,
      primary: {
        main: Colors.GREY500,
        contrastText: Colors.WHITE,
      },
      secondary: {
        main: Colors.YELLOW400,
      },
      background: {
        default: Colors.GREY50,
      },
      ...getTransColorsObj(),
    },
    components: {
      MuiButtonGroup: muiButtonGroup,
      MuiStepLabel: muiStepLabel,
      MuiMenuItem: muiMenuItem,
      MuiPaper: muiPaper,
      MuiFormControl: muiFormControl,
      MuiAppBar: muiAppBar,
      MuiToolbar: muiToolbar,
      MuiTabs: muiTabs,
      MuiTab: muiTab,
      MuiIconButton: muiIconButton,
      MuiButton: muiButton,
      MuiIcon: muiIcons,
      MuiSvgIcon: muiSvgIcons,
      MuiAlert: muiAlert,
      MuiLink: muiLink,
      MuiChip: muiChip,
      MuiBadge: muiBadge,
      MuiSwitch: muiSwitch,
      MuiTextField: muiTextField,
      MuiTooltip: muiTooltip,
      haloIcon: sfHaloIcon,
      MuiDivider: muiDivider,
      MuiListSubheader: muiListSubheader,
      MuiCheckbox: muiCheckbox,
      MuiAccordionSummary: muiAccordionSummary,
      MuiFormControlLabel: muiFormControlLabel,
      MuiSlider: muiSlider,
      MuiRating: muiRating,
      MuiFormHelperText: muiFormHelperText,
      MuiCalendarPicker: muiCalendarPicker,
      MuiDialog: muiDialog,
      MuiToggleButton: muiToggleButton,
      MuiToggleButtonGroup: muiToggleButtonGroup,
    },
  });

  return theme;
};

export default getTheme;
